    <div class="selection-block-wrapper">
      <div class="plan-container" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree)}">
        <div *ngIf="isUpgradePlansFlow && includeLabelFree" class="popular-label-container">
          <span class="popular-label">Current Plan</span>
        </div>
        <div *ngIf="!isUpgradePlansFlow && includeLabelBusiness" class="popular-label-container">
          <span class="popular-label">most popular</span>
        </div>
        <div class="plan-icon-container">
          <capra-icon [icon]="'icon-' + iconType" class="capra-plan-icon" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree)}"></capra-icon>
        </div>
        <div class="plan-title-container">
          <span class="plan-title" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree)}">{{planTitle}}</span>
        </div>
        <div class="plan-description-container">
          <span class="plan-description" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree)}">
            {{planDescription}}
          </span>
        </div>
        <span [ngStyle]="{'visibility': 'hidden'}" class="without-price"></span>
        <div class="plan-btn-container" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree)}">
          <div *ngIf="!isUpgradePlansFlow">
            <button class="btn plan-btn btn-style" [ngClass]="{'business': includeLabelBusiness}" (click)="onButtonClick()">{{ planbuttonValue }}</button>
          </div>
          <div *ngIf="isUpgradePlansFlow && !includeLabelFree">
            <mode-calendly-popup-button
                class="btn plan-btn btn-style"
              >
                {{ planbuttonValue }}
            </mode-calendly-popup-button>
          </div>
          <div *ngIf="isUpgradePlansFlow && includeLabelFree">
          <button class="btn plan-btn btn-style" [ngClass]="{'business': (isUpgradePlansFlow && includeLabelFree)}" (click)="goBack()">Back to my free workspace</button>
          </div>
        </div>
        <p *ngIf="!isUpgradePlansFlow" class="no-credit-card-container" [ngClass]="{'no-credit-card-business-text business': (!isUpgradePlansFlow && includeLabelBusiness)}" [hidden]="!shouldShowNoCreditCard">
            No credit card required!
        </p>
        <p *ngIf="isUpgradePlansFlow" class="no-credit-card-container" [ngClass]="{'no-credit-card-business-text business': (isUpgradePlansFlow && includeLabelFree)}" [hidden]="!shouldShowNoCreditCard">
            No credit card required!
        </p>
        <span class="features-subhead" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree), 'features-subhead-credit-card': true}">{{planFeaturesSubhead}}</span>
        <div class="features-container">
            <ul class="list-items-container with-added-top-margin with-added-top-margin-no-credit-card">
              <li *ngFor="let feature of planFeatures; let i = index" class="list-item" [ngClass]="{'business': (!isUpgradePlansFlow && includeLabelBusiness) || (isUpgradePlansFlow && includeLabelFree)}">{{ feature }}</li>
            </ul>
        </div>
      </div>
    </div>